import { $t, LANG ,WORKBENCH_TYPE} from "@/utils"
export const COMMON_PATH = '/fe/ticket'
export const APP_KEY = 'omega3ceb5b88f4';
export const TOOL = {
    driverInfoModify: 'driverInfoModify',
    driverCarInfoChange: 'driverCarInfoChange',
    passengerInfoModify: 'passengerInfoModify',
    driverRegCheck: 'driverRegCheck'
}
/* 补偿工具 */
export const FROM_NAME = {
    TICKETID: 'ticketid',
    ORDERID: 'orderId',
    OPERATETYPE: 'operateType',
    REASON: 'reason',
    COUPONBUSINESSTYPE: 'couponBusinessType',
    PRICE: 'price',
    AMOUNT: 'amount',
    CONTENT: 'content',
    TAGS: 'tags',
    PHONE: 'phone',
}

// 表单 type
export const FROM_TYPE = {
    INPUT: 'Input',
    SELECT: 'Select',
    TEXTAREA: 'TextArea',
    COMPON: 'FormCompon',
}

export const ROAMPHONEPREFIX = "+86"
export const LAST_TICKET_TAB_NUMBER = 10

export const DRIVER_TYPE = 2 // 司机
export const PASSENGER_TYPE = 1 // 乘客
export const FLEET_TYPE = 5 //车头
export const ENTREGA_TYPE = -3 // 闪送业务线（商家）role

let _userType = {
    'B': DRIVER_TYPE, // 司机
    'C': PASSENGER_TYPE, // 乘客
    'Fleet': FLEET_TYPE, //车头
}

let _userLabel = {
    'B': $t('CS_improvement_Driver_ZOiL'), // 司机
    'C': $t('CS_1_Passengers_rXbp'), // 乘客
    'Fleet': $t('CS_thpoptimization__sSiH'), //车头  CS_thpoptimization__sSiH
    // 'Fleet': '车头', //车头
}

export const TICKET = 'TICKET'
export const USERTYPEB = 'USERTYPEB'
export const ORDER = 'ORDER'
export const USERTYPEC = 'USERTYPEC'
export const USERTYPEF = 'USERTYPEF'
export const HISTORYTICKET = 'HISTORYTICKET'
export const DRIVER = 'DRIVER'
export const PASSENGER = 'PASSENGER'
export const MESSAGEINFO = 'MESSAGEINFO'

export const USER_TYPE = _userType
export const USER_LABEL = _userLabel
export const TICKET_STATUS_CLOSE_TYPE = 1  // 工单关单状态

export const clipperListArr = [{
    name: 'clipper.ticketID',
    type: 'id',
    label: $t('clipper.ticketID'),
}, {
    name: 'clipper.creationDate',
    type: 'creationDate',
    label: $t('clipper.creationDate'),
}, {
    name: 'clipper.T2first',
    type: 'SLA_L2_firstClaimDate',
    label: $t('clipper.T2first'),
}, {
    name: 'clipper.T3first',
    type: 'SLA_L3_firstClaimDate',
    label: $t('clipper.T3first'),
}, {
    name: 'clipper.status',
    type: 'status',
    label: $t('clipper.status'),
}]

export const processCardIntervalTime = 86400000

export const dateFormat = 'YYYY-MM-DD HH:mm:ss'

export const ESCALATE_KEY = 'ticket_escalate'


// 操作按钮
export const OPT_BTN_SAVE = 'save' // 保存按钮名称
export const OPT_BTN_CLOSE = 'close' // 关闭按钮名称
export const OPT_BTN_RESOLVED = 'resolved' // 已解决按钮名称
export const OPT_BTN_HANDLE = 'handle' // 处理按钮名称
export const OPT_BTN_TEMPORARLLY = 'temporarlly' // 暂存按钮名称

export const PERMISS_RESOLVED = 'ticket_resolve' // 已解决按钮权限点
export const PERMISS_TEMPORARLLY = 'ticket_save_pending' // 暂存按钮权限点
export const PERMISS_ESCALATE = 'ticket_escalate' // 工单流转按钮权限点
export const PERMISS_CLOSE = 'ticket_close' // 工单关闭按钮权限点
export const PERMISS_OUTER_REPLY = 'ticket_outer_reply' // 工单流转按钮权限点

export const ACTION_RESOLVE = 'ticket_resolve' // 已解决接口action value值
export const ACTION_TEMPORARLLY = 'ticket_save_pending' // 暂存接口action value值

export const ASYNC_MESSAGE = 'ticket_async_message' // 原渠道异部消息

export const OPT_BTN_DATA = {
    [OPT_BTN_SAVE]: { // 保存
        actionName: '',
        sucMsg: $t('CS_page_Successfully_created_ffvZ'),
        errMsg: $t('CS_page_Unable_to_aXip')
    },
    [OPT_BTN_CLOSE]: { // 关闭按钮
        actionName: '',
        checkmessage:$t('CS_page_Do_you_tMFN'),
        sucMsg: $t('CS_page_Work_orders_MRDt'),
        errMsg: $t('CS_page_Unable_to_lQkV')
    },
    [OPT_BTN_RESOLVED]: { // 已解决
        actionName: ACTION_RESOLVE,
        checkmessage: $t('CS_page_Whether_the_pGhP'),
        sucMsg: $t('CS_page_Work_order_vikw'),
        errMsg: $t('CS_page_Unable_to_sJgg')
    },
    [OPT_BTN_TEMPORARLLY]: {// 暂存
        actionName: ACTION_TEMPORARLLY,
        checkmessage: $t('CS_page_If_you_RZwt'),
        sucMsg: $t('CS_page_Successful_temporary_sFHU'),
        errMsg: $t('CS_page_Unable_to_lWwm')
    }
}

// 工具key
export const TOOL_CALCU_KEY = 'dev_jhZlpd4B' // 计算器
export const TOOL_LINEUP_KEY = 'dev_3C9T3zab' // 司机排队查询工具
export const TOOL_REWARD_KEY = 'dev_OdtLoywq' // 司机奖励查询
export const TOOL_EXAMINE_KEY = 'dev_0HpOK9gi' // 司机注册审核信息
export const TOOL_EXCELLENT_KEY = 'dev_NpTZaOsG' // 优享资质标准
export const TOOL_COMPENSATE_KEY = 'dev_Compensate' // 补偿工具

export const TOOL_RIDERACQUISITION_KEY = 'dev_magellan_pax_riderAcquisition' // 乘客拉新
export const TOOL_PROMOCODE_KEY = 'dev_magellan_pax_promoCode' // 兑换码
export const TOOL_ACQUISITION_KEY = 'dev_magellan_driver_acquisition' // 司机拉新工具 Acquisition
export const TOOL_DIVE_KEY = 'dev_magellan_driver_DIVE' // DIVE工具
export const TOOL_MEMBER_KEY = 'dev_magellan_pax_member_get_member' // 乘推乘查询工具

// 历史工单 补偿id跳转url
export const compensateJumpTo = `${window.location.host}/fe/ark_fe?lang=${LANG}#/ark/compensate-detail?id=`

// 历史工单 跳转工单页
export const ticketJumpTo = `${window.location.host}/fe/ticket/ark_fe?lang=${LANG}#/ticket/detail?ticketId=`

// 历史工单 订单id跳转url
export const orderJumpTo = `${window.location.host}/fe/ticket/ark_fe?lang=${LANG}#/ticket/order?order_id=`

// 历史工单 工单类型筛选项（因为是固定的，前端来维护）
export const ticketCategories = [
    {
        "name": $t("CS_tickets_Order_Work_UDue"),
        "type": "0"
    },
    {
        "name": $t("CS_tickets_Enter_the_FCWt"),
        "type": "1"
    },
    {
        "name": $t("CS_tickets_Complaint_Manner_UWAQ"),
        "type": "2"
    }
]
// 司机星级等级
export const driverStarLevel = ['Gold', 'Diamond', 'Ruby', 'Silver', 'Copper']
export const PARMS_ORDERID_NAME = 'orderId'
export const PRICE_DIGITS = !isNaN(Number(localStorage.getItem("priceDigits"))) ? Number(localStorage.getItem("priceDigits")) : 2 // 金额支持小数点几位，2:分
export const RECOM_CR_NUM = 3 // 推荐cr展示个数  recomCRPage

export const CHANNEL_PHONE_TYPE =  1 // 电话渠道类型
export const ASYNCHRONOUS_TYPE =  'offline' // 0:im, 1:电话, 2:异步

// 埋点转换 workbench_type
const WORKBENCH_TYPE_OBJ : any = {
    'offline' : '1',
    'livechat' : '2',
    'phone' : '3',
}

export const ON_WORKBENCH_TYPE = WORKBENCH_TYPE_OBJ[WORKBENCH_TYPE] || '1'
export const SHOWTYPETAB = 'tab'


